export default __webpack_public_path__ + "static/media/idea-bg-animation.e25f91ba.gif";